var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPieChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.20312C13.3132 2.20313 14.6136 2.46178 15.8268 2.96433C17.0401 3.46688 18.1425 4.20347 19.0711 5.13206C19.9997 6.06065 20.7363 7.16304 21.2388 8.3763C21.7413 9.58955 22 10.8899 22 12.2031M12 2.20312V12.2031M12 2.20312C6.47715 2.20312 2 6.68028 2 12.2031C2 17.726 6.47715 22.2031 12 22.2031C17.5228 22.2031 22 17.726 22 12.2031M12 2.20312C17.5228 2.20312 22 6.68028 22 12.2031M22 12.2031L12 12.2031M22 12.2031C22 13.7812 21.6265 15.3369 20.9101 16.743C20.1936 18.1491 19.1546 19.3657 17.8779 20.2933L12 12.2031",
    stroke: "#02222B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPieChart);
export default __webpack_public_path__ + "static/media/icon_pieChart.59bbfe2cf96fa9d6ee6b212582cab30f.svg";
export { ForwardRef as ReactComponent };